// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - CARD HEADER ||============================== //

export default function CardHeader(theme: Theme) {
  return {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.text.dark,
          padding: '26px 28px 20px'
        },
        title: {
          fontFamily: `'Poppins', sans-serif`,
          fontSize: '1.25rem',
          fontWeight: 700,
          color: theme.vars.palette.secondary.dark
        }
      }
    }
  };
}
